export const PROFIT_EXAMPLE_STORAGE_KEY = "profit_example_shown";
